angular.module('relayHealth').constant('INVOICE_TYPES', {
  LANGUAGE: 'language',
  RELAY: 'relay',
});
